//import React from "react";
import "./FiltersDefBlock.css";
import { toSafeSimpleHtml } from "../../../../utils/safeHtml.js";

const FiltersDefBlock = ({ text, couleur }) => {

    const str = toSafeSimpleHtml(text);
    return (
        <div
            className="filters-def-block"
            role="status" aria-live="polite"
            style={{ backgroundColor: couleur }}
        >
            <div
                className="filters-def-content"
                dangerouslySetInnerHTML={{ __html: str }}
            />
        </div>
    );
};

export default FiltersDefBlock;





